import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions} from "../actions/actionCreators";
import LatestTeaserTile from "../components/TeaserTile/LatestTeaserTile";
import translate from '../services/translation';


@connect(
	state => {
		return {
			teasers: state.teaser.teasers
		}
	},
	dispatch => {
		return {
			updateFilter: (filter, pagination) => dispatch(actions.filter.update(filter, pagination))
		};
	}
)
export default class LatestTeaserApp extends Component {

    static propTypes = {
    	newsLink: PropTypes.string,
		agendaLink: PropTypes.string,
		blogLink: PropTypes.string,

		tags: PropTypes.string,
		contentTypes: PropTypes.string
    };

	componentDidMount() {
		this.props.updateFilter(
			{
				tags: this.props.tags !== '' ? this.props.tags.split(',').map((tagUid) => {
					return {uid: tagUid};
				}) : [],
				logicalOperator: 1,
				contentTypes: this.props.contentTypes
			},
			{
				limit: 4,
				offset: 0,
				moreData: false
			}
		);
	}


	render() {

		return (
			<div className="latestTeaserAppContainer">
				<div className="latestTeaserLinks">
					<a href={this.props.newsLink}>{translate('latest_teaser.link_news')}</a>
					<a href={this.props.agendaLink}>{translate('latest_teaser.link_agenda')}</a>
					<a href={this.props.blogLink}>{translate('latest_teaser.link_blog')}</a>
				</div>
				<div className="teaserList latestTeaserList">
					{
						this.props.teasers.map((teaser, index) => {
							return <LatestTeaserTile key={index} id={index} teaser={teaser} />
						})
					}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/apps/LatestTeaserApp.js